import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
    backgroundColor: '#FAFCFF',
    minWidth: '715px',
  },
}));

export const CloseButtonBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
}));

export const CloseIcon = styled(IconButton)(({ theme }) => ({
  margin: '20px 20px -50px 0',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));

export const DialogContainer = styled(Box)(() => ({
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
}));

export const Title = styled(Typography)(() => ({
  fontWeight: '600',
  fontSize: '22px',
  marginBottom: '20px',
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: '600',
  color: '#1A1A1A',
  textAlign: 'start',
  span: {
    color: theme.palette.primary.main,
  },
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  width: '100%',
  minWidth: 220,
  border: `1px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  textTransform: 'lowercase',
  '&:disabled': {
    filter: 'opacity(50%)',
  },
}));

export const AssociateButton = styled(Button)(({ theme }) => ({
  width: '100%',
  minWidth: 220,
  display: 'flex',
  backgroundColor: theme.palette.secondary.main,
  '&:disabled': {
    filter: 'opacity(50%)',
  },
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const SpaceAroundBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-around',
  gap: 20,
  marginTop: 20,
}));

export const WorkOrderCard = styled(Grid)(() => ({
  padding: 20,
  border: `1px solid #D7D8DB`,
  borderRadius: 10,
}));

export const OSLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
  '&:hover': {
    color: theme.palette.secondary.main,
  },
}));

export const SmallStyledInput = styled(Typography)(() => ({
  fontWeight: '600',
  textAlign: 'justify',
}));

export const CarouselContainer = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
}));

export const ScrollableBox = styled(Box)(({ theme }) => ({
  scrollBehavior: 'smooth',
  padding: '12px 8px',
  gap: 8,
  display: 'flex',
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    height: 6,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 10,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
}));

export const ArrowButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  '&:hover': {
    color: theme.palette.secondary.main,
    background: 'transparent',
  },
}));
